export function matchesExpirationSearch(
  product: string,
  lot: string | null,
  search: string,
): boolean {
  const query = search.trim().toLocaleLowerCase('it-IT');
  return query === ''
    || product.toLocaleLowerCase('it-IT').includes(query)
    || lot?.toLocaleLowerCase('it-IT').includes(query) === true;
}
